import { ScrollSpy } from "bootstrap";

export default class ScrollSpyer {
  constructor(node) {
    this.element = node;
    this.targetWrapper = this.element.querySelector(".js-scrollspy-wrapper");
    this.headerElement = document.querySelector("header");

    this.targets = [];
    this.scrollSpyInstance = null;

    this.initialize();
  }

  initialize() {
    // TODO: Once https://github.com/twbs/bootstrap/issues/36431 is fixed, we can resolve issues with skipping some targets (This happens when multiple targets are visible at the same time)
    this.scrollSpyInstance = new ScrollSpy(this.element, {
      target: this.targetWrapper,
      smoothScroll: true,
      threshold: [1, 0.5, 0.25],
    });

    this.targetWrapper.querySelectorAll("a").forEach((link) => {
      const targetElement = document.querySelector(link.getAttribute("href"));

      if (!targetElement) return;

      this.targets.push(targetElement);

      link.addEventListener("click", () => {
        const previousOffsetTop = this.scrollSpyInstance._previousScrollData.visibleEntryTop;

        // We reset the scrollMarginTop for all the targets except the one that we are scrolling towards
        this.targets.forEach((target) => {
          if (target === targetElement) return;
          target.style.scrollMarginTop = "0px";
        });

        if (previousOffsetTop > targetElement.offsetTop || previousOffsetTop == targetElement.offsetTop) {
          // Scrolling up or at the same position (in both cases, the header is visible)
          targetElement.style.scrollMarginTop = this.headerElement.offsetHeight + "px";
        }
      });
    });
  }
}
